import {
  SortDirectionEnum,
  SortDirectionType,
} from '../data-access/models/enums';

export function trimOrNull(value?: string | null): string | null {
  const trimmed = value?.trim();
  return trimmed || null;
}

export function toNumberOrNull(value?: string | null): number | null {
  const parsed = Number(value?.trim() || NaN);
  return Number.isNaN(parsed) ? null : parsed;
}

export function mapSortDirection<T>(
  direction: SortDirectionType | undefined,
  values: { ascending: T; descending: T },
): T | null {
  if (!direction) {
    return null;
  }
  return direction === SortDirectionEnum.asc
    ? values.ascending
    : values.descending;
}
